import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { apiRequest } from "src/async/apiUtils";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import { AuthContext } from "src/context/auth";
import { useSiteSettings } from "src/context/SiteSettingsContext";
import { useUpdateSocketToken } from "src/context/SocketContext";
import { useWorkspaceSwitching } from "src/context/WorkspaceSwitchingContext";
import { clearCookies } from "src/helpers";
import { getNavigateLink } from "src/helpers/userHelper";

const Authorization = () => {
  const { token } = useParams();
  const { setUser } = useContext(AuthContext);

  const navigate = useNavigate();
  const updateSocketToken = useUpdateSocketToken();
  const { reloadSettings } = useSiteSettings();

  const { startSwitching, finishSwitching } = useWorkspaceSwitching();

  startSwitching();

  const getRedirectLink = async () => {
    try {
      const { data: resData } = await apiRequest("GET", `/portal/users/workspaces/page`);

      if (resData.status === 200) {
        const navigate_link = getNavigateLink(resData);
        navigate(navigate_link);
      } else {
        toast.error("No workspace found.");
        navigate("/permission-denied");
      }
    } catch (err) {
      toast.error(err.message);
      navigate("/permission-denied");
    }
  };

  const tokenVerify = async () => {
    try {
      localStorage.clear();
      clearCookies();
      setUser(null);

      const { data } = await apiRequest("get", `/portal/switch-to-user-token/verify`, { body: { token } });
      localStorage.setItem("email", data?.data.email);
      localStorage.setItem("accessToken", data?.access_token);
      localStorage.setItem("refreshToken", data?.refresh_token);
      updateSocketToken(data?.access_token);
      window.postMessage({ type: "LOGIN_SUCCESS", token: data?.access_token }, "*");
      await reloadSettings();
      await getRedirectLink();
    } catch (error) {
      finishSwitching();
      navigate("/login");
    }
  };

  useEffect(() => {
    if (token) tokenVerify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Preloader text="Authentication..." />
    </div>
  );
};

export default Authorization;
